import { InputAdornment, TextField as MuiTextField } from '@material-ui/core';
import { useStyles } from '@webapps/styles';
import PropTypes from 'prop-types';

const TextField = ({ InputProps, endAdornment, label, ...props }) => {
  const {
    css,
    theme: { fontSizes },
  } = useStyles();

  return (
    <MuiTextField
      label={label}
      size="small"
      variant="outlined"
      disableUnderline
      {...props}
      className={css({
        fontFamily: 'Roboto',
        '.MuiInputLabel-shrink': {
          // transform: 'translate(14px, -12px) scale(0.75)',
          backgroundColor: 'transparent',
          color: '#5D75A8',
        },
        '.MuiInputLabel-outlined': {
          color: '#5D75A8',
        },
        '.MuiFormLabel-root.Mui-disabled': {
          color: '#5D75A8',
        },
        '.MuiFilledInput-root': {
          border: '1px solid #C0D9FF',
          borderRadius: 6,
          backgroundColor: '#F3F7FF',
          color: '#152652',
        },
        '.MuiFormLabel-root': {
          color: '#5D75A8',
        },
        '.MuiFilledInput-underline:before': {
          border: 'none',
        },
        '.MuiAutocomplete-inputRoot': {
          padding: '0 !important',
          paddingRight: '14px !important',
          paddingLeft: '8px !important',
          paddingTop: '8px !important',
        },
        '.MuiFormControl-root': {
          padding: '0 !important',
          paddingRight: '14px !important',
          paddingLeft: '8px !important',
          paddingTop: '8px !important',
        },
        '.MuiInputLabel-formControl': {
          top: 6,
        },

        '.MuiChip-label': {
          color: '#5D75A8',
        },
        borderRadius: 5,
        height: '100%',
        '.MuiInputBase-input': {
          color: '#152652',
        },
      })}
      InputLabelProps={{
        disableUnderline: true,
        classes: {
          root: css({
            fontWeight: 400,
            '@media only screen and (max-width:1920px)': { fontSize: '13.500px' },
            '@media only screen and (max-width:1600px)': { fontSize: '13.5000px' },
          }),
        },
      }}
      InputProps={{
        ...InputProps,
        disableUnderline: true,
        classes: {
          root: css({
            minHeight: 42,
            borderRadius: 6,
            height: '100%',
            '@media only screen and (max-width:1920px)': { fontSize: '13.500px' },
            '@media only screen and (max-width:1600px)': { fontSize: '13.5000px' },
            textOverflow: 'hidden',
            color: '#152652',
          }),
          notchedOutline: css({ borderColor: '#C0D9FF !important' }),
        },
        endAdornment:
          InputProps?.endAdornment ??
          (!!endAdornment && (
            <InputAdornment
              classes={{
                root: css({
                  p: {
                    '@media only screen and (max-width:1920px)': {
                      fontSize: '13.500px',
                    },
                    '@media only screen and (max-width:1600px)': {
                      fontSize: '13.5000px',
                    },
                    fontWeight: 400,
                  },
                }),
              }}
              position="end"
            >
              {endAdornment}
            </InputAdornment>
          )),
      }}
    />
  );
};

TextField.propTypes = {
  label: PropTypes.node,
  InputProps: PropTypes.object,
  endAdornment: PropTypes.node,
};

export default TextField;
